export default {
  labels: {
    dont_have_account: 'Nu ai cont? ',
  },
  title: 'Alătură-te {{name}}!',
  default_program_name: 'Club de recompense',
  buttons: {
    sign_up: 'Înregistrează-te',
  },
};
